import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import {
  DetailInfo,
  SetApiPasswordType,
} from 'src/app/shared/types/api-instruction.type';

@Injectable({
  providedIn: 'root',
})
export class ApiInstructionService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/apiinstructioninfo`;
  }

  getDetailInfo(): Observable<DetailInfo> {
    return this.http.get<DetailInfo>(`${this.baseUrl}`);
  }

  configureApiPsw(body: SetApiPasswordType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/generate-api-password`,
      body
    );
  }
}
